
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/casestudy/irctc",
      function () {
        return require("private-next-pages/casestudy/irctc.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/casestudy/irctc"])
      });
    }
  